export default class KeyData {
    constructor() {
        this.data = '';
        this.paragraph = '';
    }
}
